import { useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import DivixLogo from "../assets/img/divixNegro.png";
import { getAzulResponseParams, AzulPaymentResponse } from "../services/dtos/response/AzulResponseDto";
import TipService from "../services/TipService";
import UserService from "../services/UserService";
import { GetEmployeeResponseDto } from "../services/dtos/response/UserResponseDto";
import { UpdateTipStatusDto } from "../services/dtos/request/UpdateTipStatusDto";
import { TipStatus } from "../services/dtos/TipStatus";

export function PaymentCancelledPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const userIdFromUrl = params.get("userId");
  const branchIdFromUrl = params.get("branchId");
  
  const [azulResponse, setAzulResponse] = useState<AzulPaymentResponse | null>(null);
  const [employee, setEmployee] = useState<GetEmployeeResponseDto | null>(null);
  const [tipStatusUpdated, setTipStatusUpdated] = useState(false);
  const tipService = useMemo(() => new TipService(), []);
  const userService = useMemo(() => new UserService(), []);

  // Capturar respuesta de Azul al cargar la página
  useEffect(() => {
    const responseParams = getAzulResponseParams();
    
    if (Object.keys(responseParams).length > 0) {
      setAzulResponse(responseParams);
    }
  }, [tipService]);

  // Actualizar status del tip a CANCELADA si hay tipId (se ejecuta cuando employee está disponible)
  useEffect(() => {
    // Evitar ejecutar múltiples veces
    if (tipStatusUpdated) {
      return;
    }

    // Esperar a que el employee esté disponible antes de actualizar
    if (!employee) {
      return;
    }

    // Obtener tipId de localStorage o sessionStorage (guardado antes de redirigir a Azul)
    let tipIdFromStorage = null;
    tipIdFromStorage = sessionStorage.getItem('azulTipId');
    
    if (tipIdFromStorage) {
      const tipId = parseInt(tipIdFromStorage, 10);
      
      if (isNaN(tipId)) {
        return;
      }
      
      setTipStatusUpdated(true);
      
      const updateData = new UpdateTipStatusDto();
      updateData.TipId = tipId;
      updateData.Status = TipStatus.CANCELADA;
      
      // Incluir CountryCode si el employee está disponible
      if (employee?.countryIsoCode) {
        updateData.CountryCode = employee.countryIsoCode.toUpperCase();
      }
      
      tipService.updateStatusTipInProcess(
        updateData,
        () => {},
        (errorMessage) => {
          console.error("[AZUL] Error al actualizar status:", errorMessage);
        }
      );
    }
  }, [tipService, employee, tipStatusUpdated]);

  // Obtener employee para poder incluir CountryCode
  useEffect(() => {
    const fetchEmployee = async () => {
      if (!userIdFromUrl) return;
      
      try {
        await userService.getEmployee(
          {
            userid: +userIdFromUrl,
            branchid: +branchIdFromUrl!,
          },
          (data) => {
            setEmployee(data);
          },
          (error) => {
            console.error("[AZUL] Error al obtener employee:", error);
          }
        );
      } catch (error) {
        console.error("[AZUL] Error al obtener employee:", error);
      }
    };

    if (userIdFromUrl && branchIdFromUrl) {
      fetchEmployee();
    }
  }, [userService, userIdFromUrl, branchIdFromUrl]);

  return (
    <div className="flex flex-col min-h-screen">
      <div 
        className="h-56 flex items-center justify-center pt-20"
        style={{
          backgroundColor: "#e0e0e0",
        }}
      >
        <img 
          className="mx-auto"
          style={{
            maxWidth: '180px',
            maxHeight: '90px',
            width: 'auto',
            height: 'auto',
            objectFit: 'contain'
          }}
          src={DivixLogo} 
          alt="Logo" 
        />
      </div>
      <div className="text-center mt-12 mx-auto max-w-md px-4">
        <h1 
          className="text-3xl mb-4"
          style={{
            color: "#3a3a3a",
          }}
        >
          Pago Cancelado Exitosamente
        </h1>
        <div className="max-w-60 mx-auto pt-2 pb-10">
          <span 
            className="text-xl text-center"
            style={{
              color: "#3a3a3a",
            }}
          >
          </span>
        </div>
        <a
          className="text-white inline-flex mb-4 bg-primary rounded-full py-1 px-3"
          href="https://www.divix.net"
        >
          www.divix.net
        </a>
      </div>
    </div>
  );
}

